import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MUIButton } from 'app/components/Form/Button/MUIButton.jsx';
import { Autocomplete } from 'app/components/Form';
import classes from 'app/pages/HR/HRSettings/PeopleTableEditor/PeopleTableEditorToolbar.module.scss';
const PeopleTableEditorToolbar = ({ options, selected, onSelectTable, addTable }) => {
    return (_jsxs("div", { className: classes.TopToolbarContainer, children: [_jsx(MUIButton, { color: "primary", "data-testid": "button-create-new-table", onClick: addTable, children: "Create new table" }), _jsx(Autocomplete, { options: options, placeholder: "Search a table", selected: selected, onChange: onSelectTable, searchable: true })] }));
};
export default PeopleTableEditorToolbar;
